import React from "react";
import { Link } from "react-router-dom";

export interface LoginFormStandardValues {
  username: string;
  password: string;
}

interface LoginFormStandardProps {
  values: LoginFormStandardValues;
  onChange: (field: keyof LoginFormStandardValues, value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onSwitchToSystem: () => void;
  isLoading: boolean;
  error: string;
}

const LoginFormStandard: React.FC<LoginFormStandardProps> = ({
  values,
  onChange,
  onSubmit,
  onSwitchToSystem,
  isLoading,
}) => {
  const { username, password } = values;
  const disabled = isLoading || !username.trim() || !password.trim();

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label
          htmlFor="std-username"
          className="block text-sm font-medium text-gray-600 mb-1.5"
        >
          Username
        </label>
        <input
          id="std-username"
          type="text"
          value={username}
          onChange={(e) => onChange("username", e.target.value)}
          placeholder="Enter your username"
          className="input-field"
          disabled={isLoading}
          autoComplete="username"
        />
      </div>
      <div className="flex flex-col">
        <div className="flex items-center justify-between mb-1.5">
          <label
            htmlFor="std-password"
            className="block text-sm font-medium text-gray-600"
          >
            Password
          </label>
          
        </div>
        <input
          id="std-password"
          type="password"
          value={password}
          onChange={(e) => onChange("password", e.target.value)}
          placeholder="Enter your password"
          className="input-field"
          disabled={isLoading}
          autoComplete="current-password"
        />
        <Link
            to="/forgot-password"
            className="text-xs text-primary-600 hover:text-primary-700 font-medium transition-colors self-end mt-1"
          >
            Forgot password?
          </Link>
      </div>
      <p className="text-xs text-gray-500 text-center">
        By signing in, you agree to our{" "}
        <Link
          to="/privacy-policy"
          className="text-primary-600 hover:text-primary-700 underline"
        >
          Privacy Policy
        </Link>
      </p>
      <button
        type="submit"
        disabled={disabled}
        className="w-full btn-primary mt-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? "Signing in..." : "Sign In"}
      </button>

      <div className="pt-4 text-center">
        <p className="text-sm text-gray-600">
          Don't have an organization?{" "}
          <Link
            to="/register-org"
            className="font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            Register here &rarr;
          </Link>
        </p>
      </div>

      <div className="pt-4 text-center">
        <button
          type="button"
          onClick={onSwitchToSystem}
          className="text-gray-400 hover:text-gray-600 text-sm transition-colors"
        >
          System Administrator Access
        </button>
      </div>
    </form>
  );
};

export default LoginFormStandard;
